import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { PaymentRootScreenParamList } from "../../../../types";
import { PaymentScreen } from "../PaymentScreen/PaymentScreen";
import { GiveChangeBackScreen } from "../GiveChangeBackScreen";
import React from "react";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { useCheckoutContextProvider } from "../../utils/checkout";
import { PaymentRootScreenContext } from "./context";
import { usePaymentControllerProvider } from "../../utils/payment-controller";
import { GiftCardPaymentRootScreen } from "../GiftCardPaymentScreen";

export type PaymentRootScreenProps = StackScreenProps<
  {
    PaymentRootScreen: {
      paymentMethodId: string;
      tenderedAmount?: number;
      minTenderAmount?: number;
    };
  },
  "PaymentRootScreen"
>;

export const PaymentRootScreen = ({
  navigation,
  route,
}: PaymentRootScreenProps) => {
  const [paymentMethod, setPaymentMethod] = React.useState<
    PaymentMethod | undefined
  >(undefined);
  const { setTenderedAmountInput } = usePaymentControllerProvider();

  const paymentMethodId = route.params.paymentMethodId;

  const { selectablePaymentMethods } = useCheckoutContextProvider();

  React.useEffect(() => {
    setPaymentMethod(
      selectablePaymentMethods.find((pm) => pm.id === paymentMethodId)
    );
  }, [selectablePaymentMethods, setPaymentMethod, paymentMethodId]);

  React.useEffect(() => {
    if (route.params.tenderedAmount) {
      setTenderedAmountInput(route.params.tenderedAmount.toString());
    }
  }, [route.params.tenderedAmount]);

  const Drawer = createStackHeaderNavigator<PaymentRootScreenParamList>();

  if (!paymentMethod) {
    return null;
  }

  return (
    <PaymentRootScreenContext.Provider
      value={{
        paymentMethod,
        tenderedAmount: route.params.tenderedAmount,
        minTenderAmount: route.params.minTenderAmount,
      }}
    >
      <Drawer.Navigator
        screenOptions={{
          headerShown: true,
          animationEnabled: true,
          gestureEnabled: false,
          headerLeft: () => null,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          title: "",
        }}
      >
        <Drawer.Group
          screenOptions={{
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Drawer.Screen name="PaymentScreen" component={PaymentScreen} />
        </Drawer.Group>
        <Drawer.Group>
          <Drawer.Screen
            name="GiveChangeBackScreen"
            component={GiveChangeBackScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerShown: false,
          }}
        >
          <Drawer.Screen
            name="GiftCardPaymentRootScreen"
            component={GiftCardPaymentRootScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </PaymentRootScreenContext.Provider>
  );
};
